import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  loading: false,
  error: null,
  paymentType: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    paymentStart(state, action) {
      state.loading = true;
      state.error = null;
      state.paymentType = action?.payload || null;
    },

    paymentSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },

    paymentFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    setPaymentType(state, action) {
      state.paymentType = action.payload;
    },

    clearPayment(state) {
      state.data = null;
      state.error = null;
      state.loading = false;
      state.paymentType = null;
    },
  },
});

export const {
  paymentStart,
  paymentSuccess,
  paymentFailure,
  setPaymentType,
  clearPayment,
} = paymentSlice.actions;

export default paymentSlice.reducer;
